import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryKnoOrganizationSelectOption = makeCreateDictionarySelectOption<IKnoOrganizationDictionary>(
  'id',
  'fullName',
);
